module.exports = __webpack_public_path__ + "static/frank-d9414f8447f5bcc15ab776331aa9f3c1.jpg";